import { GoogleSession, OneLoginSession } from '../../types'

export function saveSession(session: GoogleSession | OneLoginSession) {
  const sessionString = JSON.stringify(session)
  localStorage.setItem('TD_INTERNAL_SESSION', sessionString)
}
